import React from 'react';
import WaitingRoomPlayer from './WaitingRoomPlayer';
import { WaitingRoomPlayersInterface } from './WaitingRoomPlayersInterface';

function WaitingRoomFourPlayers({players, isHost}: WaitingRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="fourPlayersWrapper1">
                <WaitingRoomPlayer name={players[3].name} image={players[3].image}/>
            </div>
            <div className="fourPlayersWrapper2">
                <WaitingRoomPlayer name={players[1].name} image={players[1].image}/>
                <WaitingRoomPlayer name={players[2].name} image={players[2].image}/>
            </div>
            <div className="fourPlayersWrapper3">
                <WaitingRoomPlayer name={players[0].name} image={players[0].image}/>
            </div>
        </div>
    );
};

export default WaitingRoomFourPlayers;